import getContext from 'recompose/getContext';
import PropTypes from 'prop-types';
import { branch, compose, renderComponent, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { equals } from 'ramda';
import { get } from 'lodash';
import CustomerReminder from '../components/CustomerReminder';
import withMinuteOptions from '../../hoc/withMinuteOptions';
import BrandBarberCustomerReminderContainer from './BrandBarberCustomerReminder';

const shouldUpdateSecondReminder = (props) => {
  // Handle cases where time objects might be undefined during language switches
  if (!props.barberReminderTime || !props.reminderTime) {
    return false;
  }
  const barberHours = Number(props.barberReminderTime.hours);
  const barberMinutes = Number(props.barberReminderTime.minutes);
  const reminderHours = Number(props.reminderTime.hours);
  const reminderMinutes = Number(props.reminderTime.minutes);
  if (barberHours === reminderHours) return barberMinutes <= reminderMinutes;
  return barberHours < reminderHours;
};

const handleReminderChange = withPropsOnChange(
  (props, nextProps) => (
    !equals(props.barberReminderTime, nextProps.barberReminderTime) ||
    !equals(props.reminderTime, nextProps.reminderTime)
  ),
  (props) => {
    if (shouldUpdateSecondReminder(props) && props.barberReminderTime) {
      const barberHours = Number(props.barberReminderTime.hours);
      const barberMinutes = Number(props.barberReminderTime.minutes);
      const minutes = props.minuteOptions[props.minuteOptions.indexOf(barberMinutes) - 1] || 0;
      const hours = barberMinutes ? barberHours : barberHours - 1;
      props.change(props.form, `${props.name}.reminder.time`, { hours, minutes });
    }
  }
);

export const mapStateToProps = (state, ownProps) => {
  const form = ownProps._reduxForm.form;
  const formValues = getFormValues(form)(state);
  return {
    form,
    barberReminderTime: get(formValues, `${ownProps.name}.barber_reminder.time`),
    reminderTime: get(formValues, `${ownProps.name}.reminder.time`),
  };
};

const CustomerReminderContainer = compose(
  branch(
    props => props.formSectionName,
    renderComponent(BrandBarberCustomerReminderContainer)
  ),
  getContext({
    _reduxForm: PropTypes.object,
  }),
  withMinuteOptions,
  connect(
    mapStateToProps,
    { change },
  ),
  handleReminderChange,
)(CustomerReminder);

export default CustomerReminderContainer;
